import { colors } from '@ardoq/design-tokens';
import {
  MATERIAL_ICONS_DEFAULT_FONT_SIZE,
  ShapeType,
  IconSize,
} from '@ardoq/icons';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';

export const EXPANDER_WIDTH = MATERIAL_ICONS_DEFAULT_FONT_SIZE;
export const ICON_MARGIN = 4;
export const ICON_WIDTH = 18;
export const TIMELINE_PHASES_HEIGHT = 20;
export const MODERNIZED_TIMELINE_PHASES_HEIGHT = 24;
export const TIMELINES_ITEM_ROW_HEIGHT = 32;

const TIMELINE_LINK_MARGIN_LEFT = 16;
export const TIMELINE_LINK_WIDTH = 28;
export const TIMELINE_LINK_RIGHT_OFFSET = 2;
export const TIMELINE_CHILD_INDENTATION =
  TIMELINE_LINK_WIDTH + TIMELINE_LINK_MARGIN_LEFT + TIMELINE_LINK_RIGHT_OFFSET;

export const EXPANDER_BUTTON_SIZE = 16;
export const EXPANDER_BUTTON_RIGHT_MARGIN = 8;

export const TIMELINE_MODERNIZED_GROUP_INDENTATION = 32;
const TIMELINE_MODERNIZED_CHILD_INDENTATION = 12;
export const TIMELINE_MODERNIZED_COMPONENT_INDENTATION =
  EXPANDER_BUTTON_SIZE +
  EXPANDER_BUTTON_RIGHT_MARGIN +
  TIMELINE_MODERNIZED_CHILD_INDENTATION;

export const TIMELINE_LINK_COLOR = colors.grey300;
export const TIMELINE_MODERNIZED_LINK_COLOR = colors.grey400;

export const TIMELINE_LINK_BULLETPOINT_COLOR = colors.grey500;
export const LABELS_COLUMN_BACKGROUND_COLOR = colors.grey50;
export const TIMELINE_MILESTONE_SIZE = 24;
export const TIMELINE_MILESTONE_MARGIN =
  (TIMELINES_ITEM_ROW_HEIGHT - TIMELINE_MILESTONE_SIZE) / 2;

export const TIMELINES_MILESTONE_SHAPES = [
  // this order is determined by design
  // https://ardoqcom.atlassian.net/browse/ARD-17808
  ShapeType.DIAMOND,
  ShapeType.SQUARE,
  ShapeType.CIRCLE,
  ShapeType.TRIANGLE,
  ShapeType.PENTAGON,
  ShapeType.HOURGLASS,
  ShapeType.QUATREFOIL,
];

export const CONTEXT_ITEM_BACKGROUND_COLOR = `${colors.blue400}A4`;

// colors.grey200 is #E6E7E9. We want to have transparency of 0.7 on a white background.
// Using the alpha blending formula, the color we need is #DBDDE0
export const HIGHLIGHTED_ITEM_BACKGROUND_COLOR = '#DBDDE0';

export const TIMELINE_LABEL_CONTAINER_PADDING_X = 4;
export const Y_AXIS_MARGIN_TIMELINE = 8;
export const X_AXIS_MARGIN_TIMELINE = 4;

const TEXT_2_LINE_HEIGHT = 20;
export const TEXT_2_BOLD_REACT_STYLE = {
  fontFamily: ARDOQ_DEFAULT_FONT_FAMILY,
  fontSize: '14px',
  lineHeight: `${TEXT_2_LINE_HEIGHT}px`,
  fontWeight: 600,
};

export const TIMELINE_INFINITE_PHASE_INDICATOR_WIDTH = 12;

export const COLOR_INDICATOR_WIDTH = 4;

const ICON_AREA_WIDTH = ICON_WIDTH + ICON_MARGIN * 2;
export const TIMELINE_LABEL_COLUMN_PADDINGS =
  TIMELINE_LABEL_CONTAINER_PADDING_X * 2 +
  X_AXIS_MARGIN_TIMELINE * 2 +
  COLOR_INDICATOR_WIDTH +
  ICON_MARGIN;
export const TIMELINE_LABEL_WITH_ICON_COLUMN_PADDINGS =
  TIMELINE_LABEL_COLUMN_PADDINGS + ICON_AREA_WIDTH;

export const TIMELINE_INDIVIDUAL_ITEM_MARGIN =
  EXPANDER_BUTTON_SIZE +
  EXPANDER_BUTTON_RIGHT_MARGIN -
  TIMELINE_LABEL_CONTAINER_PADDING_X;

export const MARGIN_BETWEEN_ROWS = 4;

export const TIMELINE_FIELD_DATA_EXPANDER_WIDTH = IconSize.LARGE;

export const OTHER_LABEL_VERTICAL_MARGIN = 4;
export const OTHER_LABEL_LINE_HEIGHT = TEXT_2_LINE_HEIGHT;
export const OTHER_LABEL_MAX_LINES = 2;
export const OTHER_LABEL_GAP_FACTOR = 0.05;
